module.exports = __webpack_public_path__ + "img/warning.7a3b1534.svg";